// extracted by mini-css-extract-plugin
export default {"main":"jeqp5","tablet":"PCTEv","desktop":"Rs1UZ","layout":"jzJ6g"};